import Radio from 'antd/lib/radio'
import RadioGroup from './radio-group'
import 'antd/lib/radio/style'

export * from 'antd/lib/radio'

// @ts-ignore
Radio.Group = RadioGroup

export default Radio
